export default "__VITE_ASSET__OBQ07$Q0__"